import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 md:px-8 lg:px-16 bg-indigo-50" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl text-center" data-id="element-145">
          <div className="flex justify-center mb-6" data-id="element-146">
            <Shield size={60} className="text-indigo-600" data-id="element-147" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-900" data-id="element-148">
            Garantía Incondicional de 7 Días
          </h2>
          <p className="text-lg text-gray-700 mb-8" data-id="element-149">
            Estamos tan seguros de que experimentarás una transformación
            significativa con el programa 30 Días Frecuencia Prohibida que te
            ofrecemos una garantía total:
          </p>
          <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-6 mb-8" data-id="element-150">
            <p className="text-xl font-bold text-indigo-900 mb-4" data-id="element-151">
              Si después de seguir el programa durante 7 días no experimentas
              resultados, te devolvemos el 100% de tu dinero.
            </p>
            <p className="text-gray-700" data-id="element-152">
              Sin preguntas complicadas. Sin condiciones ocultas. Queremos que
              tomes esta decisión con total confianza y tranquilidad.
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6" data-id="element-153">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9kd3RitfzZwH6aN97YFVSC/Screenshot_2025-09-13_at_5.55.28_PM.png" alt="Fundador del programa" className="w-24 h-24 rounded-full object-cover" data-id="element-154" />
            <div className="text-left" data-id="element-155">
              <p className="italic text-gray-700 mb-2" data-id="element-156">
                "He creado este programa con todo mi corazón y experiencia.
                Estoy tan seguro de su efectividad que quiero eliminar cualquier
                riesgo para ti. Si no funciona para ti, no quiero tu dinero."
              </p>
              <p className="font-bold text-indigo-900" data-id="element-157">
                Gabriel Beltran, Creador de 30 Días Frecuencia Prohibida
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}